import { RouterProps, useNavigate } from '@reach/router';
import React, { useEffect, useState } from 'react';
import { appDispatch, RootState } from '../../store/store';
import { getMyCompanies } from '../../store/companies/companiesSlice';
import Carousel from '../Carousel/Carousel';
import styled from 'styled-components';
import { getDomainAndPort, Hosts } from 'api/Utils';
import { useTranslation } from 'react-i18next';
import { ICompany } from '../../store/companies/companiesTypes';
import hamyar from 'assets/images/hamyar-popup.jpg';

import {
  badgeCardBg,
  black,
  boxShadow1,
  cardBorder,
  exactWhite,
  red,
  stringToColour,
} from '../../utils/style/colors';
import Icon from '../../components/Icon/Icon';
import LoadingCircleIndicator from '../../components/LoadingCircleIndicator/LoadingCircleIndicator';
import NavLink from '../../components/NavLink/NavLink';
import prompt from '../../assets/images/camp412-1.jpg';
import prompt2 from '../../assets/images/camp412-2.jpg';
import prompt3 from '../../assets/images/camp412-3.jpg';
import staffTraining from '../../assets/images/Stuff-training.jpg';
import itWebinar from '../../assets/images/it-webinar.jpg';
import rastech1402 from '../../assets/images/rastech-1402.jpg';
import rastechSat from '../../assets/images/rastech-sat.jpg';
import nabetasadof from '../../assets/images/nabetasadof.jpg';
import feature_zero from '../../assets/images/new-features/Rastech-update-0.png';
import feature_go from '../../assets/images/new-features/Rastech-update-go.png';
import feature_one from '../../assets/images/new-features/Rastech-update-1.jpg';
import feature_two from '../../assets/images/new-features/Rastech-update-2.jpg';
import feature_three from '../../assets/images/new-features/Rastech-update-3.jpg';
import feature_four from '../../assets/images/new-features/Rastech-update-4.jpg';
import feature_five from '../../assets/images/new-features/Rastech-update-5.jpg';
import feature_six_one from '../../assets/images/new-features/Rastech-update-6-1.jpg';
import feature_six_two from '../../assets/images/new-features/Rastech-update-6-2.jpg';
import feature_seven from '../../assets/images/new-features/Rastech-update-7.jpg';
import feature_eight from '../../assets/images/new-features/Rastech-update-8.jpg';
import feature_nine from '../../assets/images/new-features/Rastech-update-9.jpg';
// import feature_ten from '../../assets/images/new-features/Rastech-update-10.jpg';
import feature_eleven from '../../assets/images/new-features/Rastech-update-11.jpg';

import { useSelector } from 'react-redux';
import {
  IUserInfo,
  makhsanSelfUserInfo,
} from '../../store/makhsanUserInfo/makhsanUserInfoSlice';
import i18n from 'i18next';
import moment from 'moment-jalaali';
import Modal from '../../components/Modal';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import { myLoginActivity } from '../../api/MakhsanApi';
import {
  IUserSecurityEvent,
  LogType,
} from '../../store/entity/IUserSecurityEvent';
import logo from '../../assets/images/rastech-with-type.png';
import { LoginWarnInfo, LogItem, Logo } from './styles';
import { languageDirection } from '../../i18n';
// import DarkModeClass from '../../hooks/DarkModeClass';

import logMessages from '../Tasks/UserProfile/Messages';
import { smartDateString } from '../../utils/date';
import BadgeProfileDropdown from '../../components/Dropdown/BadgeProfileDropdown';
import { UserBadgeContainer } from '../Mobile/Profile/ProfileHead/styles';
import Slider, { Settings } from 'react-slick';
import {
  getUserFlags,
  setAddOrUpdateUserFlag,
} from '../../store/thisUser/thisUserSlice';
import { summerizeText } from 'utils/summerizeText';

interface IHomePageProps {
  path?: string;
}

interface PromptInfo {
  actionTitle?: string;
  key: string;
  endDate: number;
  startDate: number;
  showOnce: boolean;
  image?: any;
  link: string;
  description?: string;
  excludeDomain?: Hosts[];
}
const promptList: PromptInfo[] = [
  {
    key: 'camp412-1',
    endDate: 1709000522838,
    startDate: 170906580000,
    showOnce: false,
    image: prompt,
    link: 'https://rstk.ir/insta',
  },
  {
    key: 'camp412-2',
    endDate: 1709086936211,
    startDate: 1709000522838,
    showOnce: false,
    image: prompt2,
    link: 'https://rstk.ir/insta',
  },
  {
    key: 'camp412-3',
    endDate: 1709173336211,
    startDate: 1709086936212,
    showOnce: false,
    image: prompt3,
    link: 'https://rstk.ir/insta',
  },
  {
    key: 'campUserTrain',
    endDate: 1716669000000,
    startDate: 1705656900441,
    showOnce: false,
    image: staffTraining,
    link: 'https://rastech.health/fa/request-demo',
  },
  {
    key: 'mohammad',
    endDate: 1717273800000,
    startDate: 1705656900441,
    showOnce: false,
    image: itWebinar,
    link: 'https://rstk.ir/webinar-register',
  },
  {
    key: '1402',
    startDate: 1719915691955,
    endDate: 1720557000000,
    showOnce: false,
    image: rastech1402,
    link: 'https://rstk.ir/Performance-Report',
  },
  {
    key: 'sat-1403',
    startDate: 1739946529075,
    endDate: 1741178060245,
    showOnce: false,
    image: rastechSat,
    link: 'https://rstk.ir/sat',
  },
  {
    key: 'nabetasadof',
    startDate: 1756200064000,
    endDate: 1756372893000,
    showOnce: false,
    image: nabetasadof,
    link: 'https://nabetasadof.ir/',
  },
  {
    key: 'hamyar',
    startDate: 1756192288000,
    endDate: 1757488288000,
    showOnce: false,
    image: hamyar,
    link: 'https://app.rastech.ir/help#chat',
    excludeDomain: [
      'accreditation.ir',
      'webda.ir',
      'webda.rastech.ir',
      'dashboard.vchealth.ir',
      'nabetasadof.ir',
    ],
  },
];

const satisficationSeasonRange = [
  {
    monthNumber: 2,
    dayRange: {
      start: 8,
      end: 18,
    },
  },
  {
    monthNumber: 5,
    dayRange: {
      start: 21,
      end: 31,
    },
  },
  {
    monthNumber: 8,
    dayRange: {
      start: 20,
      end: 30,
    },
  },
  {
    monthNumber: 11,
    dayRange: {
      start: 20,
      end: 30,
    },
  },
];

const HomePageContainer = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem;
  background: var(--exact-white);
`;

const CarouselContainer = styled.div`
  margin-top: 1rem;
  height: 20%;
`;

const Container = styled.div`
  height: 100%;
  width: 90%;
  margin: 0 auto;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: flex-start;
`;

const Header = styled.h2`
  font-weight: bold;
  font-size: 1.5rem;
  color: ${black};
`;

const LogoContainer = styled.div`
  /* display: flex;
  align-items: center;
  justify-content: center; */
`;

const CompanyContainer = styled.div`
  width: 100%;
  box-shadow: ${boxShadow1};
  border-radius: 0.75rem;
  padding: 1rem;
  margin: 1rem 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
`;

const CompanyItem = styled.div`
  height: 5rem;
  width: 20rem;
  gap: 0.5rem;
  border-radius: 1rem;
  border: ${cardBorder};
  display: flex;
  flex-direction: row;
  overflow: hidden;
  box-shadow: ${boxShadow1};

  &:hover {
    cursor: pointer;
  }
`;

const CompanyBadgeItem = styled.div`
  width: 10rem;

  ${(props) =>
    `background-image: linear-gradient(to ${props.theme.direction === 'rtl' ? 'left' : 'right'}, ${props.color} 0%, var(--exact-white) 100%);`}
  color: var(--exact-white);
  display: flex;
  align-items: center;
  justify-content: start;
  padding-inline-start: 1rem;
`;

const CompanyContentItem = styled.div`
  width: calc(100% - 7rem);
  height: 5rem;
  margin-inline-start: -7rem;
  font-weight: bold;
  font-size: 1rem;

  display: flex;
  align-items: flex-start;
  justify-content: center;

  flex-grow: 1;
  border-radius: 1rem;
  padding: 0.8rem 1rem;
  flex-direction: column;
  /* text-align: center; */
  color: ${black};
  background: ${badgeCardBg};
  border-inline-start: ${cardBorder};
  overflow: hidden;

  & > div {
    display: inline-flex;
    align-items: center;
  }
`;

const NewFeaturesContainer = styled.div`
  width: 100%;
  height: 80vh;
  display: flex;
  align-items: center;
  margin: 0 auto;
  overflow-x: hidden;

  .slick-slider {
    width: 100% !important;
    height: 100% !important;
  }

  .slick-list {
    height: 100% !important;
  }

  .slick-track {
    height: 100% !important;
  }

  .slick-dots {
    bottom: 0 !important;
  }
`;

const Image = styled.div`
  width: 100% !important;
  height: 80vh;
  border-radius: 1rem;
  background: ${(props) =>
    `url(${props.background}) center center/contain no-repeat`};
`;

const HomePage: React.FC<IHomePageProps & RouterProps> = () => {
  const { t } = useTranslation('general');

  const navigate = useNavigate();

  const state = useSelector((state: RootState) => state);
  const thisUser = useSelector((state: RootState) => state.thisUser);
  const homepageFlags = useSelector(
    (state: RootState) => state.thisUser.userFlags?.['homepage']
  );

  const [loading, setLoading] = useState<boolean>(false);
  const [companies, setCompanies] = useState<ICompany[]>([]);
  const [userPasswordStatus, setUserPasswordStatus] = useState<
    boolean | undefined
  >(undefined);
  const [hidePrompt, setHidePrompt] = useState<boolean>(false);
  const [dontShowThisMessageAgain, setDontShowThisMessageAgain] =
    useState<boolean>(false);
  const [dontShowTimeZoneError, setDontShowTimeZoneError] =
    useState<boolean>(false);
  const [lastFailedLogin, setLastFailedLogin] = useState<
    IUserSecurityEvent | undefined
  >(undefined);
  const [forceShowFeatureModal, setForceShowFeatureModal] =
    useState<boolean>(false);
  const [dismissedFeatureModal, setDismissedFeatureModal] =
    useState<boolean>(false);

  const enableFeatureModal =
    forceShowFeatureModal ||
    (homepageFlags !== undefined &&
      !dismissedFeatureModal &&
      homepageFlags.find((el) => el.flagName === 'disableShowFeature')
        ?.flagValue !== 'true');

  const settings: Settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    rtl: true,
    arrows: true,
  };

  useEffect(() => {
    setLoading(true);
    appDispatch(getMyCompanies({}))
      .then((res: any) => {
        setCompanies(res.companies);
      })
      .finally(() => {
        setLoading(false);
      });

    handleFetchLogin();

    appDispatch(makhsanSelfUserInfo({ userId: Number(thisUser.userId) })).then(
      (e: { userInfos: IUserInfo[] }) => {
        setUserPasswordStatus(
          localStorage.getItem('setPassword') === 'true' ||
            e.userInfos[0]?.hasPassword
        );
      }
    );
  }, []);

  useEffect(() => {
    const fetchFlags = async () => {
      await appDispatch(getUserFlags({ flagGroup: 'tour' }));
      await appDispatch(getUserFlags({ flagGroup: 'homepage' }));
    };
    fetchFlags();
  }, []);

  const handleSetModalVisited = async (flagName: string) => {
    await appDispatch(
      setAddOrUpdateUserFlag({
        flagName: flagName,
        flagValue: 'true',
        flagGroup: 'homepage',
      })
    );
  };

  const preventPrompt = (key: string) => {
    localStorage.setItem(key, 'true');
  };

  const handleFetchLogin = () => {
    myLoginActivity(state).then((result) => {
      const failed = result.data.filter(
        (log, index) =>
          index < 5 &&
          (log.type === LogType.Unsuccessful_Authenticate_2FA ||
            log.type === LogType.Unsuccessful_Authenticate_Mobile ||
            log.type === LogType.Unsuccessful_Authenticate_Pass ||
            log.type === LogType.Unsuccessful_Authenticate_SAC) &&
          log.date > new Date().getTime() - 10 * 60 * 60 * 24 * 1000
      );
      if (failed.length > 0) setLastFailedLogin(failed[0]);
    });
  };

  // if (companies.length === 1) {
  //   return <Redirect to={`/t/${companies[0].id}/home`} />;
  // }

  const now = new Date().getTime();
  let promptInfo = promptList.find((it) => {
    return (
      !it.excludeDomain?.includes(getDomainAndPort().domain as Hosts) &&
      it.startDate < now &&
      it.endDate > now &&
      localStorage.getItem(it.key) !== 'true'
    );
  });
  if (userPasswordStatus === false) {
    promptInfo = {
      key: 'setPassword',
      link: '/c/profile#password',
      description: i18n.t('setPasswordPrompt', {
        ns: 'general',
      }) as string,
      endDate: 0,
      startDate: 0,
      showOnce: false,
      actionTitle: 'ثبت کلمه عبور',
    };
  }
  const timeZoneError =
    localStorage.getItem('timeZoneError') === 'true'
      ? false
      : new Date().getTimezoneOffset() !== -210;

  if (!promptInfo) {
    const currentMonth = moment(now).jMonth();
    const currentDate = moment(now).jDate();
    const isSatisPopupNotification = satisficationSeasonRange.find((item) => {
      return (
        item.monthNumber === currentMonth &&
        currentDate >= item.dayRange.start &&
        currentDate <= item.dayRange.end
      );
    });
    const currentYear = moment(now).jYear();
    const satKey = `${currentYear}-${currentMonth}`;
    const disableShowAgain = localStorage.getItem(satKey) === 'true';
    if (isSatisPopupNotification && !disableShowAgain) {
      promptInfo = {
        key: satKey,
        startDate: moment()
          .valueOf()
          // .jYear(currentYear)
          // .jMonth(isPopupNotification.monthNumber)
          // .jDate(isPopupNotification.dayRange.start)
          // .toDate()
          .valueOf(),
        endDate: moment().valueOf(),
        // .jYear(currentYear)
        // .jMonth(isPopupNotification.monthNumber)
        // .jDate(isPopupNotification.dayRange.end)
        // .toDate()
        // .valueOf(),
        showOnce: false,
        image: rastechSat, // need to be change
        link: 'https://rstk.ir/sat',
      };
    }
  }

  return (
    <HomePageContainer>
      {/* <DarkModeClass /> */}
      {promptInfo && promptInfo.image !== '' && (
        <Modal
          width="unset"
          title={''}
          onClose={() => {
            if (
              (dontShowThisMessageAgain || promptInfo?.showOnce) &&
              promptInfo?.key
            )
              preventPrompt(promptInfo.key);
            setHidePrompt(true);
          }}
          isActive={!hidePrompt}
          mainStyle={{
            background: exactWhite,
            border: '0px',
            height: 'fit-content !important',
            maxHeight: '90%',
          }}
          height={'fit-content'}
          // isAlert={!promptInfo.image}
        >
          {promptInfo.image && (
            <img
              style={{
                maxHeight: '70vh',
                maxWidth: '90vw',
                margin: 'auto',
                cursor: 'pointer',
              }}
              src={promptInfo.image}
              alt="no-company"
              onClick={() => {
                promptInfo?.link && window.open(promptInfo.link, '_blank');
              }}
            />
          )}
          {promptInfo.description && (
            <p style={{ margin: '1rem' }}>{promptInfo.description}</p>
          )}
          {!promptInfo.image && promptInfo.link && (
            <Button
              color="green"
              onClick={() => {
                if (promptInfo?.link) navigate?.(promptInfo.link);
              }}
            >
              {promptInfo.actionTitle}
            </Button>
          )}
          {!promptInfo.showOnce && (
            <Input
              wrapperStyle={{ margin: '10px' }}
              id={'dontShowThisMessage'}
              type="checkbox"
              label={
                i18n.t('dontShowThisMessageAgain', {
                  ns: 'general',
                }) as string
              }
              checked={dontShowThisMessageAgain}
              onChange={(e) => {
                setDontShowThisMessageAgain(e.target.checked);
              }}
            />
          )}
        </Modal>
      )}

      {
        <Modal
          width="unset"
          title={t('newFeature')}
          onClose={() => {
            setForceShowFeatureModal(false);
            setDismissedFeatureModal(true);
            handleSetModalVisited('disableShowFeature');
          }}
          isActive={enableFeatureModal}
          mainStyle={{
            background: '#fdfdfd',
            border: '0px',
            maxWidth: '60rem',
            width: '90%',
            margin: 'auto',
          }}
        >
          <NewFeaturesContainer className="slider-container">
            <Slider {...settings}>
              <Image
                background={feature_go}
                onClick={() => {
                  setForceShowFeatureModal(false);
                  setDismissedFeatureModal(true);
                  handleSetModalVisited('disableShowFeature');
                }}
              />
              <Image background={feature_eleven} />
              <Image background={feature_nine} />
              <Image background={feature_eight} />
              <Image background={feature_seven} />
              <Image background={feature_six_two} />
              <Image background={feature_six_one} />
              <Image background={feature_five} />
              <Image background={feature_four} />
              <Image background={feature_three} />
              <Image background={feature_two} />
              <Image background={feature_one} />
              <Image background={feature_zero} />
              {/*<Image background={feature_ten} />*/}
            </Slider>
          </NewFeaturesContainer>
        </Modal>
      }

      <Modal
        width="unset"
        title={i18n.t('errorInSystemSettigns', { ns: 'general' }) as string}
        onClose={() => {
          if (dontShowTimeZoneError) preventPrompt('timeZoneError');
          setDontShowTimeZoneError(true);
        }}
        isActive={timeZoneError}
        mainStyle={{
          background: exactWhite,
          border: '0px',
          maxWidth: '95%',
          margin: 'auto',
        }}
      >
        <p style={{ color: red }}>
          <Icon type="clock" style={{ margin: '10px' }} />
          {i18n.t('timeZoneError', { ns: 'general' }) as string}
        </p>
        <Input
          wrapperStyle={{ margin: '10px' }}
          id={'timezoneError'}
          type="checkbox"
          label={
            i18n.t('dontShowThisMessageAgain', {
              ns: 'general',
            }) as string
          }
          checked={dontShowTimeZoneError}
          onChange={(e) => {
            setDontShowTimeZoneError(() => e.target.checked);
          }}
        />
      </Modal>

      <UserBadgeContainer
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '90%',
          margin: '0 auto',
        }}
      >
        <LogoContainer>
          <Logo>
            <img
              src={logo}
              alt="rastech"
              onClick={() => setHidePrompt(false)}
            />
          </Logo>
        </LogoContainer>
        <BadgeProfileDropdown
          user={thisUser}
          direction={'right'}
          isHidden={false}
          isThemeEnabled={true}
        />
      </UserBadgeContainer>

      {lastFailedLogin && (
        <LoginWarnInfo style={{}}>
          <LogItem
            level={lastFailedLogin.level}
            key={lastFailedLogin.id.toString()}
            className="row"
          >
            <div
              className="col s12 m4"
              style={{
                float: languageDirection() === 'rtl' ? 'right' : 'left',
              }}
            >
              {logMessages[lastFailedLogin.type]}
            </div>
            <div
              className="col s12 m4"
              style={{
                float: languageDirection() === 'rtl' ? 'right' : 'left',
              }}
            >
              {logMessages.date +
                ': ' +
                smartDateString(new Date(lastFailedLogin.date), true)}
            </div>
            <Button href="/c/profile" color="blue" className="col s4">
              {i18n.t('showLoginHistory', { ns: 'general' }) as string}
            </Button>
          </LogItem>
        </LoginWarnInfo>
      )}
      <CarouselContainer>
        <Carousel
          folderId={276424}
          onShowNewVersionModal={() => {
            setForceShowFeatureModal(true);
          }}
          thisUser={thisUser}
          onDismissModal={(id) => handleSetModalVisited(id)}
        />
      </CarouselContainer>
      <Container>
        <Header>{t('companiesList')}</Header>
        <CompanyContainer>
          {loading ? (
            <div className="h-full" style={{ margin: 'auto' }}>
              <LoadingCircleIndicator />
            </div>
          ) : companies.length > 0 ? (
            companies.map((company: ICompany) => (
              <NavLink path={`/t/${company.id}/home`} key={company.id}>
                <CompanyItem>
                  <CompanyBadgeItem color={stringToColour(company.name)}>
                    <Icon
                      type="briefcase"
                      style={{ fontSize: '1.5rem' }}
                      color={exactWhite}
                    />
                  </CompanyBadgeItem>
                  <CompanyContentItem>
                    {summerizeText(company.name, 57)}
                  </CompanyContentItem>
                </CompanyItem>
              </NavLink>
            ))
          ) : (
            <p
              style={{
                textAlign: 'center',
                marginTop: '10px',
                width: '100%',
                height: '100%',
              }}
            >
              {i18n.t('youDoNotHaveAnyCompany', { ns: 'general' }) as string}
            </p>
          )}
        </CompanyContainer>
      </Container>
    </HomePageContainer>
  );
};

export default HomePage;
